import React from "react";
import { LogIn } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";

// Master-only: opens a new tab acting fully as the target user.
export const ImpersonateButton = ({ userId, className = "" }) => {
    const go = async () => {
        try {
            const { data } = await api.post(`/access/impersonate/${userId}`);
            const url = `${window.location.origin}/acessar-como?t=${encodeURIComponent(data.token)}`;
            window.open(url, "_blank", "noopener");
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Não foi possível acessar como este usuário");
        }
    };
    return (
        <button onClick={go} data-testid={`impersonate-${userId}`} className={`inline-flex items-center justify-center gap-2 rounded-xl border border-border py-2 text-sm transition-colors hover:bg-muted ${className}`}>
            <LogIn className="h-4 w-4" /> Acessar como
        </button>
    );
};
